import BaseAction from './base'

export class AdminAction extends BaseAction {
    constructor(){
        super("user")
    }
    login(body){
        return {
            type: `LOGIN`,
            payload: body
        }
    }
    logout(){
        return {
            type: `LOGOUT`
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/actions/admin.jsx